import {
  deprecated,
  deprecatedObjectProperty,
  deprecatedProperty
} from "./chunk-4EIZQYWK.mjs";
import "./chunk-QMOEH4QX.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  deprecated,
  deprecatedObjectProperty,
  deprecatedProperty
};
//# sourceMappingURL=deprecated.mjs.map